// import React, {Component} from "react";
import SelectByList from "./selectByList";
import React from "react";

class SelectByMap extends SelectByList {

    getOptions = () => {
        const {
            itemList,
            textProperty,
        } = this.props;

        return (
            itemList.map(item => (
                <option key={item[0]} value={item[0]}>
                    {item[1][textProperty]}
                </option>
            ))
        )
    }

    getFirstOptionId = () => {
        const {
            itemList,
            valueProperty,
        } = this.props;

        return itemList[0][0];
    }

}

export default SelectByMap;
